import { PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import Receipt from '@mui/icons-material/Receipt';

export const useCreateOrderButton = () => {
  return {
    id: 8,
    name: 'Start your order',
    link: PATIENT_REFILL_ROUTE,
    icon: Receipt,
  };
};
